import { Component, OnInit, ViewChild } from "@angular/core";
import { ModalController, NavParams, IonicModule } from "@ionic/angular";

import { FilePreviewComponent } from "src/app/components/file-upload/file-preview.component";
import { Plugins } from "@capacitor/core";
import { flipIn } from "src/app/animations/custom.animation";
import {
  excelLabelForIndex,
  excelLabelToIndex,
  isExcelLineKey,
} from "../../utils/excel-line-keys.util";
import { SyndicateTicketPreviewComponent } from "../../syndicate-ticket-preview/syndicate-ticket-preview.component";
import { Router } from "@angular/router";
import { SyndicateRepositoryService } from "../../syndicate-repository.service";
import { SyndicateDataService } from "../../../../services/syndicate-data.service";
import { TrackedEventsService } from "src/app/services/tracked-events.service";
import { AuthService } from "@core/auth.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { MatDialog } from "@angular/material/dialog";
import { UserProfilePopupComponent } from "src/app/components/user-profile-popup/user-profile-popup.component";
import type { SwiperOptions } from "swiper/types";
import { SwiperComponent, SwiperModule } from "swiper/angular";
import { HeaderComponent } from "../../../../components/header/header.component";
import { DotFlashAnimationComponent } from "../../../../components/dot-flash-animation/dot-flash-animation.component";
import { NgClass } from "@angular/common";
import { InProgressAnimationComponent } from "../../../../components/in-progress-animation/in-progress-animation.component";

const { Browser } = Plugins;

@Component({
    selector: "app-private-syndicate-ticket",
    templateUrl: "./private-syndicate-ticket.component.html",
    styleUrls: ["./private-syndicate-ticket.component.scss"],
    animations: [flipIn],
    standalone: true,
    imports: [
        HeaderComponent,
        IonicModule,
        SwiperModule,
        DotFlashAnimationComponent,
        NgClass,
        InProgressAnimationComponent,
        TranslatePipe,
    ],
})
export class PrivateSyndicateTicketComponent implements OnInit {
  @ViewChild(FilePreviewComponent, { static: false }) filePreview: FilePreviewComponent;

  @ViewChild("slides") slides: SwiperComponent;

  showSlides: boolean;
  pageTitle;
  ticketSlider:SwiperOptions = {
    speed: 400,
    initialSlide: 0,
    slidesPerView: 1.1,
  };
  createSyndicate = false;
  ticketChecked = false;
  ticketData: any;
  ticketImageURL = "";
  viewTicket = false;
  ticketToBeChecked = false;
  checkedTicket = false;
  showLines = true;
  dotAnimation = false;
  showFlip: boolean;
  viewText = true;
  ticketManaged = false;
  syndicateTicketSource: any;
  syndicateDetails;
  syndicateCount: any;
  listProduct: any;
  prdIndex: any;
  syndicateTicketData: any = { product: [] };
  profilePicture: any;
  profilePictureObj: any = [];
  translatedToastMsg: any;
  selectedLanguage: string = "en";
  constructor(
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private router: Router,
    private syndicateService: SyndicateRepositoryService,
    private syndicateDataService: SyndicateDataService,
    private trackedEventsService: TrackedEventsService,
    public translate: TranslateService,
    private authService: AuthService,
    private matDialog: MatDialog
  ) {
    this.authService.selectedlanguage$.subscribe(
      (l) => {
        if (l) {
          this.selectedLanguage = l;
          translate.use(l ? l : "en");
        }
      },
      (err) => {
        return (err);
      }
    );
    this.authService.getConstantsMsg$.subscribe((msg: any) => {
      this.translatedToastMsg = msg?.static_messages_pwa;
    })
  }

  ngOnInit() {
    this.syndicateDetails = this.navParams.get("syndicate");
    this.syndicateTicketSource = this.navParams.get("source");

    this.listProduct = this.navParams.get("product");
    this.prdIndex = this.navParams.get("prdIndex");

    if (this.listProduct?.products[0] && this.listProduct != undefined) {
      if (this.listProduct?.products[0] === null || !this.listProduct?.products[0]) {
        this.ticketData = {
          syndicate_name: "Empty",
          product: [],
        };
        return;
      }

      //this.listProduct?.products.map((product) => {
      this.getSyndicateTickets();
      //});
    } else {
      this.ticketData = {
        syndicate_name: "Empty",
        product: [],
      };
      return;
    }
  }

  ionViewWillEnter() {
    this.showSlides = true;
  }

  showProfilePopup(user_id: string) {
    if (user_id) {
      this.matDialog.open(UserProfilePopupComponent, {
        panelClass: "user-profile-popup",
        // backdropClass: "decline-back-drop-color",
        data: user_id,
        disableClose: false,
      });
    } else {
      /* const msg = this.translatedToastMsg?.["1045"]?.[this.selectedLanguage];
      this.authService.showToast(msg ? msg : "There is an issue with profile popup", "Error", ""); */
      this.authService.getConstantsMsg("1045").then((translatedMsg) => {
        const defaultMsg = {
          message: {
            line_1: "There is an issue with profile popup",
            line_2: "",
          },
          style: {
            type: "error",
            icon: "tick circle error.svg",
          }
        }
        this.authService.showToastMessage(translatedMsg, defaultMsg);
      }).catch((err) => {
        return err
      });

    }
  }

  getSyndicateTickets() {
    this.syndicateService
      .getPrivateSyndicateTickets(
        this.syndicateDetails.sId
          ? this.syndicateDetails?.sId
          : this.syndicateDetails?.psId
            ? this.syndicateDetails?.psId
            : this.syndicateDetails?.id
      )
      .subscribe(
        (productDetails) => {
          this.ticketData = this.prepareTicketsData(productDetails);
          if (this.slides) {
            this.slides?.swiperRef?.slideTo(this.prdIndex);
          }
        },
        (err) => {
          return (err);
        }
      );
  }

  private prepareTicketsData(syndicateTicketData: any) {
    if (syndicateTicketData) {
      syndicateTicketData.map((ticketData, index) => {
        const tickets = [];
        if (!ticketData[0]) return;
        Object.keys(ticketData[0])
          .filter((x) => isExcelLineKey(x))
          .sort((a, b) => excelLabelToIndex(a) - excelLabelToIndex(b))
          .map((ticketRow) => {
            ticketData.map((data) => {
              if (data[ticketRow]) {
                this.fetchUserProfile(data?.user_id);
                tickets.push({
                  product_image: data?.product_image,
                  product_name: data?.product_name,
                  draw_day: data?.draw_day,
                  regularNumbers: this.getRegularNumbers(data, ticketRow),
                  bonusNumbers: this.getBonusNumbers(data, ticketRow),
                  raffle: this.getRaffleNumbers(data, ticketRow),
                  eye: this.getEyeLink(data, ticketRow),
                  profilePic: this.profilePicture,
                  user_id: data?.user_id,
                });
                ticketData.ticketLines = tickets;
              }
            });
          });
      });
    }
    return syndicateTicketData;
  }

  fetchUserProfile(userId) {
    if (this.profilePictureObj[userId]) {
      return;
    } else {
      this.authService.getUserInfoCardList(userId).subscribe((ref: any) => {
        const profilePic = ref?.profile_picture
          ? ref?.profile_picture
          : "https://s3-eu-west-1.amazonaws.com/wplivemedia/wp-content/uploads/20191126133115/user-profile-icon.png";
        this.profilePictureObj[userId] = profilePic;
      });
      return;
    }
  }

  loadUserProfile(userId) {
    const userProfileUrl = this.profilePictureObj[userId];
    return userProfileUrl;
  }

  private getBonusNumbers(ticket: any, key: any) {
    return ticket[key]
      .filter((x) => {
        return typeof x === "string" && x?.length < 6 && x.search("B") === 0;
      })
      .map((filteredData) => filteredData?.split("_")[1]);
  }

  private getRegularNumbers(ticket: any, key: any) {
    return ticket[key]
      .filter((x) => {
        return x.search("RG") === 0 && x?.length < 7;
      })
      .map((filteredData) => filteredData?.split("_")[1]);
  }

  private getRaffleNumbers(ticket: any, key: any) {
    return ticket[key]
      .filter((x) => {
        return typeof x === "string" && x?.length > 6 && x.search("R") === 0;
      })
      .map((filteredData) => filteredData?.split("_")[1]);
  }

  private getEyeLink(ticket: any, key: any) {
    if (!ticket || !key) return;
    return ticket[key]?.find((x) => {
      return typeof x === "string" && (x.search("https") === 0 || x.search("png") === 0);
    });
  }

  switchMode() {
    setTimeout(() => {
      this.showFlip = false;
      this.showLines = !this.showLines;
    }, 400);
    this.showFlip = true;
  }

  alphabeticOrder(val) {
    return excelLabelForIndex(val);
  }

  navigateToSyndicateTab() {
    this.modalCtrl.dismiss().catch((err) => {
      return err;
    });
    this.trackedEventsService.openAnimation();
    setTimeout(() => {
      if (this.router.url === "/private-syndicate/syndicate-checkout") {
        this.syndicateDataService.resetSyndicateForm();
        this.router.navigateByUrl("/mainTabs/tabs/syndicate");
      }
    }, 7000);
  }

  getSliderOptions(ticketArray: any) {
    if (ticketArray?.length === 1) {
      this.ticketSlider["centeredSlides"] = true;
    }
    return this.ticketSlider;
  }

  async setTicket(ticketImageUrl: string) {
    const modal = this.modalCtrl.create({
      component: SyndicateTicketPreviewComponent,
      componentProps: { ticketImageUrl },
      cssClass: "ticket-preview",
      showBackdrop: true,
    });
    (await modal).present();
  }

  previewTicket() {
    /* Preview ticket Image when 
    user click on camera Icon and Image Rendered on DOM*/
    if (this.ticketImageURL !== "") {
      this.filePreview.preview();
    }
  }

  openHelpTab() {
    this.openInAppBrowser("https://help.lotto-social.com/hc/en-us/?app=1");
  }

  async openInAppBrowser(urlData: string) {
    if (Browser) {
      await Browser.open({ url: urlData });
      window.open(urlData);
    }
  }

  viewPlayers(syndicate) {
    this.dotAnimation = true;
    this.syndicateDetails["cardType"] = "Private";
    this.syndicateService.viewPlayersCount(this.syndicateDetails).subscribe(
      (res: any) => {
        this.viewText = false;
        this.dotAnimation = false;
        if (res && res?.response && res?.response?.status === "SUCCESS") {
          this.syndicateCount = res?.response?.syndicate_size;
        } else {
          //this.snackService.openSnackBar("something went wrong!", "", "Error", "Error");
          /* const msg = this.translatedToastMsg?.["1015"]?.[this.selectedLanguage];
          this.authService.showToast(msg ? msg : "something went wrong!", "Error", ""); */
          this.authService.getConstantsMsg("1015").then((translatedMsg) => {
            const defaultMsg = {
              message: {
                line_1: "something went wrong!",
                line_2: "",
              },
              style: {
                type: "error",
                icon: "tick circle error.svg",
              }
            }
            this.authService.showToastMessage(translatedMsg, defaultMsg);
          }).catch((error) => {
            return error;
          });


        }
      },
      (err) => {
        return (err);
      }
    );
  }

  isRaffleAvailable(index: number) {
    return this.ticketData?.product[index]?.ticketLines?.some((x) => x?.raffle?.length);
  }

  goToSyndicateTab() {
    this.modalCtrl
      .dismiss()
      .then(() => {
        this.trackedEventsService.openAnimation();
        setTimeout(() => {
          this.router.navigate(["mainTabs/tabs/syndicate"]);
        }, 7000);
      })
      .catch((err) => {
        return err;
      });
  }

  slideChanged() {
    const index = this.slides?.swiperRef?.activeIndex;
    if (!this.slides) return;
    this.slides?.swiperRef?.update();
  }

  openSyndicates() {
    this.trackedEventsService.openAnimation();
    setTimeout(() => {
      this.router.navigateByUrl("/mainTabs/tabs/syndicate");
    }, 7000);
  }

  getLines(ticket) {
    if (ticket && ticket?.ticketLines?.length) {
      return ticket?.ticketLines?.length;
    }
  }
}
